import phone from '../../../Assets/Img/phone.png'
import pinLocation from '../../../Assets/Img/pin-location.png'
import email from '../../../Assets/Img/email.png'
import clienticon from '../../../Assets/Img/clienticon.webp'
import testicon1 from '../../../Assets/Img/testicon1.webp'
import testicon4 from '../../../Assets/Img/testicon4.webp'
import testicon5 from '../../../Assets/Img/testicon5.webp'
import clienticon2 from '../../../Assets/Img/clienticon2.webp'
import clienticon3 from '../../../Assets/Img/clienticon3.webp'
import clienticon4 from '../../../Assets/Img/clienticon4.webp'
import Footer from "../../../subComponent/Footer";
import RequestForm from "../../../subComponent/RequestForm";

const TestimonialsPage = () => {
    return (
        <div className="bg-white">
            <div className="background-setting  testiominal-background  ">
                <div className="inventory-backdrop" >
                    <div className="py-5">
                        <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Stories</p>
                        <p className="text-center text-white fs_30 poppins  m-0 ">Client Testimonial</p>
                        <p className="text-center text-white fs_18 poppins  m-0 ">Hear What They Say</p>
                    </div>
                    <div className='line3 bg-white w-100'></div>
                    <div className="container">
                        <div className="row w-100 justify-content-center  m-0">
                        <div className="col-12 col-md-6 client-icon-section position-relative">
                     
                       <div className=" mb-md-5 client-testimonial client-text  rounded-4 p-4">
                           <p className='text-center text-white'>Satheesh Kumar</p>
                           <p className=' text-center pb-3 text-white'>Group Information Technology Manager, AGX Logistics</p>
                           <p className='text-white'>“It was a pleasure to work with SmartB. The system is easy to use and the project went well as the implementation was quick and smooth.”</p>
                          
                       </div>
                       <div className="client-icon position-absolute">
                           <img src={clienticon} width="100%" alt='Your image' />
                           <div className="client-rating position-relative">
                               <button className="rating__star client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>

                           </div>
                       </div>
                   </div>
                   <div className=" col-12 col-md-6 client-icon-section position-relative">
                       <div className="  mb-md-5 client-testimonial client-text  rounded-4 p-4">
                           <p className='text-center text-white'>Mr Cheong San Wai </p>
                           <p className=' text-center pb-3 text-white'>Finance Manager, Speed Concrete</p>
                           <p className='text-white'>“Generally speaking, most things I liked about working with Alwin are that he is accommodating to the client’s requirements & excellent.</p>
                           <p className='text-white'>Other than that, the SmartB system is user friendly & affordable with value for money.”</p>
                          
                       </div>
                       <div className="client-icon position-absolute">
                           <img src={testicon1} width="100%" alt='Your image' />
                           <div className="client-rating position-relative">
                               <button className="rating__star client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>
                               <button className="rating__star  client-rating-star">★</button>

                           </div>
                       </div>
                   </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="background-setting client1-background ">
                <div className="inventory-backdrop" >
                    <div className="container">
                    <div className="row w-100 justify-content-center  m-0">
                        <div className="col-12 col-md-6 client-icon-section position-relative">
                       
                                <div className=" mb-md-5 client-testimonial client-text  rounded-4 p-4">
                                    <p className='text-center text-white'>Ms Siti Afzanizan</p>
                                    <p className=' text-center pb-4 text-white'>Sales Coordinator, Speed Concrete</p>
                                    <p className='text-white'>“Using the SmartB system has made my job easy as I no longer need to depend on hard copies. The system is user friendly too.</p>
                                    <p className='text-white'>On top of that, dealing with Arina is great as she provides fast-action and good communication with customers. She is also excellent at problem-solving with the system.”</p>
                                </div>
                                <div className="client-icon position-absolute">
                                    <img src={testicon4} width="100%" alt='Your image' />
                                    <div className="client-rating position-relative">
                                        <button className="rating__star client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>

                                    </div>
                                </div>
                            </div>
                            <div className=" col-12 col-md-6 client-icon-section position-relative">
                                <div className="  mb-md-5 client-testimonial client-text  rounded-4 p-4">
                                    <p className='text-center text-white'>Mr King Hao</p>
                                    <p className=' text-center pb-4 text-white'>Operations, Yew Siong Industrial Supplies</p>
                                    <p className='text-white'>“I liked the SmartB system for its interconnectedness and not only is it cloud-based, the system is also highly flexible and able to cope with a huge amount of data.</p>
                                    <p className='text-white'>Aside from that, Alwin & Max are very knowledgeable and prompt to work with.</p>
                                    <p className='text-white'>I would recommend SmartB to other customers as I think they can to cater to your specific needs, and if they are unable to, they will be upfront with you.”</p>
                                </div>
                                <div className="client-icon position-absolute">
                                    <img src={testicon5} width="100%" alt='Your image' />
                                    <div className="client-rating position-relative">
                                        <button className="rating__star client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>
                                        <button className="rating__star  client-rating-star">★</button>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className="background-setting client2-background ">
                <div className="inventory-backdrop" >
                    <div className="container">
                        <div className='client-icon-section position-relative '>
                            <div className=" py-5  w-100 justify-content-center gap-5 m-0 ">
                                <div className=" py-5 client-testimonial client-section rounded-4 p-4 mx-2 mx-md-5">
                                    <p className='text-center text-white'>Ms Siti Afzanizan</p>
                                    <p className=' text-center pb-4 text-white'>Strategic Planning Manager, Diyou Fibre</p>
                                    <p className='text-white  pb-4'> “The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.It’s the best since our process is very complex and weird. After we started to use SmartB in our factory, everything was digitized. So instead of using handwritten, we are now moving towards digitalization & SmartB played an important role in that.</p>
                                    <p className='text-white pb-4'>On top of that, dealing with Arina is great as she provides fast-action and good communication with customers. She is also excellent at problem-solving with the system.”</p>
                                </div>

                            </div>
                            <div className="client-icon position-absolute">
                                <img src={clienticon2} width="100%" alt='Your image' />
                                <div className="client-rating position-relative">
                                    <button className="rating__star client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="background-setting client3-background ">
                <div className="inventory-backdrop" >
                    <div className="container">
                        <div className='client-icon-section position-relative '>
                            <div className=" py-5  w-100 justify-content-center gap-5 m-0 ">
                                <div className=" py-5 client-testimonial client-section rounded-4 p-4 mx-2 mx-md-5">
                                    <p className='text-center text-white'>Ms Siti Afzanizan</p>
                                    <p className=' text-center pb-4 text-white'>Strategic Planning Manager, Diyou Fibre</p>
                                    <p className='text-white  pb-4'> “The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.It’s the best since our process is very complex and weird. After we started to use SmartB in our factory, everything was digitized. So instead of using handwritten, we are now moving towards digitalization & SmartB played an important role in that.</p>
                                    <p className='text-white pb-4'>On top of that, dealing with Arina is great as she provides fast-action and good communication with customers. She is also excellent at problem-solving with the system.”</p>
                                </div>

                            </div>
                            <div className="client-icon position-absolute">
                                <img src={clienticon3} width="100%" alt='Your image' />
                                <div className="client-rating position-relative">
                                    <button className="rating__star client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="background-setting client4-background ">
                <div className="inventory-backdrop" >
                    <div className="container">
                        <div className='client-icon-section position-relative '>
                            <div className=" py-5  w-100 justify-content-center gap-5 m-0 ">
                                <div className=" py-5 client-testimonial client-section rounded-4 p-4 mx-2 mx-md-5">
                                    <p className='text-center text-white'>Ms Siti Afzanizan</p>
                                    <p className=' text-center pb-4 text-white'>Strategic Planning Manager, Diyou Fibre</p>
                                    <p className='text-white  pb-4'> “The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.It’s the best since our process is very complex and weird. After we started to use SmartB in our factory, everything was digitized. So instead of using handwritten, we are now moving towards digitalization & SmartB played an important role in that.</p>
                                    <p className='text-white pb-4'>On top of that, dealing with Arina is great as she provides fast-action and good communication with customers. She is also excellent at problem-solving with the system.”</p>
                                </div>

                            </div>
                            <div className="client-icon position-absolute">
                                <img src={clienticon4} width="100%" alt='Your image' />
                                <div className="client-rating position-relative">
                                    <button className="rating__star client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>
                                    <button className="rating__star  client-rating-star">★</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <RequestForm />

            <div className="background-setting testimonial-footer py-5">
                <Footer />
            </div>
            </div>
 
    );
}

export default TestimonialsPage;

